import { addClass, waitForInitialization } from "@kluntje/js-utils/lib/dom-helpers";
import { LightboxArgs, SDELightbox } from "Components/sde-m-lightbox/sde-m-lightbox";
import { GENERIC_CLOSED_EVENT } from "Constants/eventTypes";

class LightboxService {
  private activeLightbox?: SDELightbox;

  public async open(options: LightboxArgs) {
    const lightbox = this.renderLightbox();
    this.activeLightbox = lightbox;
    document.body.appendChild(lightbox);
    await waitForInitialization(lightbox);
    await lightbox.openLightbox(options);
  }

  public async close() {
    if (this.activeLightbox === undefined) return;

    await this.activeLightbox.close();
    this.activeLightbox = undefined;
  }

  private renderLightbox() {
    const lightbox = document.createElement("sde-m-lightbox") as SDELightbox;
    addClass(lightbox, "sde-m-lightbox");
    lightbox.addEventListener(GENERIC_CLOSED_EVENT, () => this.handleLightboxClose(), { once: true });
    return lightbox;
  }

  private handleLightboxClose() {
    this.activeLightbox = undefined;
  }
}

export default new LightboxService();
